<template>
  <v-row justify="center" v-show="GameSyncDialog" class="dialog-container">
    <v-dialog v-model="GameSyncDialog" persistent max-width="300">
      <v-card tile flat>
        <v-card-title class="headline">Beküldés folyamatban</v-card-title>
        <v-card-text>
          <p>Kérem várjon, az ablak automatikusan be fog záródni pár másodperc múlva. Az adatok szinkronizálása
            folyamatban van....</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState('ui', ['GameSyncDialog']),
  }
}
</script>

<style scoped>

</style>
